module.exports = __webpack_public_path__ + "static/media/pikto_questy.c621bfbc.png";